import { BindingEngine } from 'aurelia-framework';
import { Disposable } from 'framework/aurelia_tools/binding-helper';
import { MapZoneDetailModel } from 'model/map-zones';

export class MapZoneLayerController {
  private isHighlightedSubscription: Disposable = null;
  private isDetailedSubscription: Disposable = null;
  private isActiveSubscription: Disposable = null;

  constructor(private bindingEngine: BindingEngine, public mapZone: MapZoneDetailModel) {
  }

  attach() {
    this.isHighlightedSubscription = this.bindingEngine.propertyObserver(this.mapZone, 'isHighlighted').subscribe(() => this.setMapZoneLayerStyle());
    this.isDetailedSubscription = this.bindingEngine.propertyObserver(this.mapZone, 'isDetailed').subscribe(() => this.setMapZoneLayerStyle());
    this.isActiveSubscription = this.bindingEngine.propertyObserver(this.mapZone, 'data').subscribe(() => this.setMapZoneLayerStyle());
    this.setMapZoneLayerStyle();
  }

  unattach() {
    this.isHighlightedSubscription.dispose();
    this.isDetailedSubscription.dispose();
    this.isActiveSubscription.dispose();
  }

  public setMapZoneLayerStyle() {
    if (this.mapZone.isDetailed)
      this.mapZone.featureCollectionLayer.setStyle({ color: 'red' })
    else if (this.mapZone.isHighlighted)
      this.mapZone.featureCollectionLayer.setStyle({ color: '#FFCC00' })
    else if (!this.mapZone.data.isActive)
      this.mapZone.featureCollectionLayer.setStyle({ color: 'gray' })
    else
      this.mapZone.featureCollectionLayer.setStyle({ color: '#2b77e5' })
  }
}
